var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeviceDesktop = function SvgDeviceDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.62 43h1.88a1 1 0 0 1 0 2h-12a1 1 0 0 1 0-2h1.87c.732-.216 1.116-.816 1.133-2H19a3 3 0 0 1-3-3V22a3 3 0 0 1 3-3h27a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H35.495c.017 1.18.398 1.782 1.125 2zm-2.739 0c-.239-.566-.365-1.237-.38-2h-2.004c-.015.763-.141 1.434-.38 2h2.764zM47 35V22a1 1 0 0 0-1-1H19a1 1 0 0 0-1 1v13h29zm0 2H18v1a1 1 0 0 0 1 1h27a1 1 0 0 0 1-1v-1z"
  })));
};
export default SvgDeviceDesktop;